import { Component, OnInit, Input, SimpleChanges, } from '@angular/core';
import { FormGroup, FormControl, } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-observation-table',
  templateUrl: './observation-table.component.html',
  styleUrls: ['./observation-table.component.scss']
})
export class ObservationTableComponent implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;

  observationtableForm: any
  jobData
  learnerData
  learnerName
  observationtableFormedit
  loading
  isEdit: boolean = false;
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    if (!this.isEdit)
      this.createForm()
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);
      this.getUserRole();
    }

    if (changes.singleLearner && changes.singleLearner.currentValue && changes.singleLearner.currentValue != undefined) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
    }
    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.observationtableFormedit = changes.assessmentEdit.currentValue
      console.log("observation data ==>", this.observationtableFormedit)
      let size = Object.keys(this.observationtableFormedit).length;
      console.log("what is the size of object", size);
      // if(size !=0 ){
      this.isEdit = true
      this.createForm(this.observationtableFormedit)
      // }
    }

    // this.createForm()
  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors,'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if(getRole.isLearner) this.isLearner = true
    else if(getRole.isTrainer) this.isTrainer = true
    else if(getRole.isIQA) this.isIQA = true

  }
  createForm(details?) {
    console.log("details data ==========>", details)
    this.observationtableForm = new FormGroup({
      observation1: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation1 : ''),
      observation2: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation2 : ''),
      observation3: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation3 : ''),
      observation4: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation4 : ''),
      observation5: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation5 : ''),
      observation6: new FormControl((details && details.observationtableForm) ? details.observationtableForm.observation6 : ''),
    })
  }

  submitobservation() {
    console.log("form data value =====>", this.observationtableForm.value)
    this.loading = true

    //  submit list object 

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        observationtableForm: this.observationtableForm.value,
      }
    }

    // services call 
    console.log("this._learnerService.submitobservation table(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('observation res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("observation not accepted", err)
    })
    // service end 
  }
}
